import _classCallCheck from "/var/jenkins/workspace/Consolidated/Code/Dev/Web@2/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/var/jenkins/workspace/Consolidated/Code/Dev/Web@2/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/var/jenkins/workspace/Consolidated/Code/Dev/Web@2/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/var/jenkins/workspace/Consolidated/Code/Dev/Web@2/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/var/jenkins/workspace/Consolidated/Code/Dev/Web@2/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import { Component } from 'react';
import { connect } from 'react-redux';
import QueryParamProxy from '../../utils/queryParamProxy';
import Screens from '..';
import { getActiveRouteName } from '../../utils/navigation';
import navigation from '../../utils/navigation/navigation';
import { REWARD_CENTER_ONBOARDING_STEPS } from '../../components/OnboardingLayer/onboardingSteps';
import { ONBOARDING_FLOWS } from '../../utils/onboarding';
import { PromoActionKey } from '../../utils/PromotionAction';
import { setOnboardingStep as _setOnboardingStep } from '../../state/actions/currentOnboarding';
import { setPromoActionRunning as _setPromoActionRunning } from '../../state/slices/actionCommands/actionCommands';
import { markOnboardingSeen as _markOnboardingSeen } from '../../state/actions/ftue';
var RewardCenterOnboarding = /*#__PURE__*/function (_Component) {
  function RewardCenterOnboarding() {
    var _this;
    _classCallCheck(this, RewardCenterOnboarding);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, RewardCenterOnboarding, [].concat(args));
    _this._clickHandler = function () {
      var _this$props = _this.props,
        markOnboardingSeen = _this$props.markOnboardingSeen,
        setOnboardingStep = _this$props.setOnboardingStep,
        navigation = _this$props.navigation,
        dismissModal = _this$props.dismissModal;
      dismissModal();
      setOnboardingStep(REWARD_CENTER_ONBOARDING_STEPS.SECOND_VISIT);
      markOnboardingSeen(ONBOARDING_FLOWS.REWARD_CENTER);
      QueryParamProxy.navigate(navigation, Screens.RewardCenter);
    };
    return _this;
  }
  _inherits(RewardCenterOnboarding, _Component);
  return _createClass(RewardCenterOnboarding, [{
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      if (getActiveRouteName(navigation.getCurrentRoute()) === Screens.Home && this.props.promoActionRunning === PromoActionKey.GO_TO_REWARDS) this.props.setPromoActionRunning(null);
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props$rewardCen, _this$props2;
      return this.props.render({
        clickHandler: this._clickHandler,
        rewardCenterOnboardingAsset: (_this$props$rewardCen = (_this$props2 = this.props) === null || _this$props2 === void 0 || (_this$props2 = _this$props2.rewardCenterAssets) === null || _this$props2 === void 0 ? void 0 : _this$props2.REWARD_CENTER_ONBOARDING) !== null && _this$props$rewardCen !== void 0 ? _this$props$rewardCen : null
      });
    }
  }]);
}(Component);
var mapStateToProps = function mapStateToProps(state) {
  return {
    isAccountLinked: state.playerInfo.isAccountLinked,
    rewardCenterAssets: state.assetsPackage.assets.REWARD_CENTER_FEATURE,
    promoActionRunning: state.actionCommands.promoActionRunning
  };
};
var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    setOnboardingStep: function setOnboardingStep(step) {
      dispatch(_setOnboardingStep(step));
    },
    markOnboardingSeen: function markOnboardingSeen(onboardingFlow) {
      dispatch(_markOnboardingSeen(onboardingFlow));
    },
    setPromoActionRunning: function setPromoActionRunning(actionType) {
      dispatch(_setPromoActionRunning(actionType));
    }
  };
};
export default connect(mapStateToProps, mapDispatchToProps)(RewardCenterOnboarding);